import { ASSET_CLASS_IDS } from "~/consts";

// // // //
// Consts shared between the home page (src/pages/index.tsx) and the home page
// components in this directory.

export const NET_FLOW_ASSET_LEGEND_WIDTH = 200;

export const TREASURY_YIELD_DISPLAY_START_DATE = "2024-01-01";
export const TREASURY_YIELD_QUERY_START_DATE = "2023-12-26";

export const HIGH_YIELD_OVERVIEW_VALUE = "overview";

export const HIGH_YIELD_ASSET_CLASS_OPTIONS = [
    {
        id: ASSET_CLASS_IDS.ActiveStrategies,
        label: "Active Strategies",
    },
    {
        id: ASSET_CLASS_IDS.AssetBackedCredit,
        label: "Asset-Backed Credit",
    },
    {
        id: ASSET_CLASS_IDS.CorporateCredit,
        label: "Corporate Credit",
    },
    {
        id: ASSET_CLASS_IDS.DiversifiedCredit,
        label: "Diversified Credit",
    },
    {
        id: ASSET_CLASS_IDS.SpecialtyFinance,
        label: "Specialty Finance",
    },
];

export const HIGH_YIELD_ASSET_CLASS_IDS = HIGH_YIELD_ASSET_CLASS_OPTIONS.map(
    (option) => option.id,
);
